import { Grid, Typography } from '@mui/material';
import maintance_image from '../../assets/manutencao.png'
export default () => {

    return (
        <Grid container justifyContent={'center'} >
            <Grid item xs={8} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <img style={{ maxWidth: '100%' }} src={maintance_image} alt="imagem manutenção" />
            </Grid>
            <Grid item  justifyContent={'center'} xs={8}>
                <Typography variant='h1' component='h1'>Nosso site está em manutenção no momento.</Typography>
                <Typography variant='h6' component='p'>Estamos realizando uma manutenção programada em nosso site para garantir um melhor desempenho e uma experiência ainda mais aprimorada para você.</Typography>
            </Grid>

        </Grid>
    )
}